import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Forward = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M2.59 25.011c0-10.724 8.685-19.409 19.409-19.409a.917.917 0 1 1 0 1.833c-9.712 0-17.576 7.865-17.576 17.576S12.287 42.587 22 42.587c9.711 0 17.575-7.865 17.575-17.576 0-5.11-2.182-9.71-5.67-12.93a.917.917 0 1 1 1.244-1.347c3.846 3.552 6.26 8.632 6.26 14.277 0 10.724-8.685 19.409-19.41 19.409-10.723 0-19.408-8.685-19.408-19.409Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M18.76.688a.917.917 0 0 1 1.296 0l5.182 5.183a.917.917 0 0 1 0 1.296l-5.182 5.182a.917.917 0 0 1-1.297-1.296l4.535-4.534-4.535-4.534a.917.917 0 0 1 0-1.297Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M21.082 6.519c0-.506.41-.917.917-.917h2.59a.917.917 0 1 1 0 1.833H22a.917.917 0 0 1-.917-.916Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.35 25.02c0 10.7-8.677 19.4-19.35 19.4-10.672 0-19.35-8.7-19.35-19.4S11.328 5.62 22 5.62h.4l-3.591-3.6c-.4-.3-.4-.9 0-1.3.399-.4.897-.4 1.296 0l5.187 5.2c.2.2.3.4.3.6 0 .3-.1.5-.3.7l-5.187 5.2c-.399.4-.897.4-1.296 0-.4-.4-.4-.9 0-1.3l3.59-3.7H22c-9.675 0-17.554 7.9-17.554 17.6 0 9.7 7.88 17.6 17.554 17.6 9.675 0 17.555-7.9 17.555-17.6 0-5.1-2.194-9.7-5.685-12.9-.4-.3-.4-.9-.1-1.3.399-.4.898-.4 1.297-.1 3.89 3.6 6.283 8.7 6.283 14.3Z"
  })));
});
Forward.displayName = 'Forward';
Forward.defaultProps = {
  'aria-label': 'Forward'
};
export default Forward;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Forward.js
// module id = 3172
// module chunks = 11